var React = require('react');

function Blockfolder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.672 5.5H21a1 1 0 0 1 1 1V7a1 1 0 1 0 2 0v-.5a3 3 0 0 0-3-3h-8.5l-1.621-1.621A3 3 0 0 0 8.757 1H3a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h3a1 1 0 1 0 0-2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5.757a1 1 0 0 1 .707.293L11.672 5.5z","fill":"#fff","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 16a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-4.523 4.89a6 6 0 0 1-8.367-8.367l8.367 8.368zm1.414-1.413-8.368-8.368a6 6 0 0 1 8.367 8.367z","fill":"#fff","key":1})]);
}

Blockfolder.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Blockfolder;

Blockfolder.default = Blockfolder;
